<template>
<div class="w-full">

    <div id="seccionImprimir2" class="contenedor-cert">
        <img src="../../../assets/images/seminarios/diploma.jpg" style="width: 100%; -webkit-print-color-adjust: exact; print-color-adjust: exact;">

        <!-- Nombre del docente -->
        <div style="font-family: font_diploma; font-size: 45px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); white-space: nowrap;">
            {{ usuario.nombres }} {{ usuario.apellidos }}
        </div>

        <!-- Título de la capacitación o encuesta -->
        <div align="center">
            <div style="font-family: font_diploma; line-height: 80%; font-size: 38px; width: 90%; position: absolute; top: 66%; left: 50%; transform: translate(-50%, -50%);">
                {{ nombreCapacitacion || encuesta.titulo }}
            </div>
        </div>

        <!-- Fecha -->
        <div style="width: 100%; padding-right: 130px; text-align: right; font-family: font_diploma; font-size: 30px; position: absolute; top: 79%; left: 50%; transform: translate(-50%, -50%);">
            {{ fechaHoy }}
        </div>
    </div>

    <vs-popup title="Sigue estos pasos para descargar tu certificado" :active.sync="popupActivo">
        <img src="../../../assets/images/seminarios/tutorialDescarga.png" style="width: 100%;"><br><br>
        <vs-button color="primary" class="w-full mb-1" type="gradient" @click="descargarCertificado()">Descargar</vs-button>
    </vs-popup>

</div>
</template>

<script>
export default {
    data() {
        return {
            popupActivo: true,
            usuario:  { nombres: '', apellidos: '' },
            encuesta: { titulo: '', codigo: '' },
            nombreCapacitacion: '',
        }
    },
    computed: {
        fechaHoy() {
            const d = new Date()
            const meses = ['enero','febrero','marzo','abril','mayo','junio',
                           'julio','agosto','septiembre','octubre','noviembre','diciembre']
            return `${d.getDate()} de ${meses[d.getMonth()]} de ${d.getFullYear()}`
        }
    },
    mounted() {
        try {
            const u = localStorage.getItem('userEncuestaProlipa')
            const e = localStorage.getItem('dataEncuestaCertificado')
            const n = localStorage.getItem('nombreEntidadEncuesta')
            if (u) this.usuario  = JSON.parse(u)
            if (e) this.encuesta = JSON.parse(e)
            if (n) this.nombreCapacitacion = n
            // Limpiar para que no persista en futuras visitas
            localStorage.removeItem('nombreEntidadEncuesta')
        } catch(err) {}
        this.valPopupDesc()
    },
    methods: {
        valPopupDesc() {
            setTimeout(() => {
                if (!this.popupActivo) {
                    this.popupActivo = true
                }
            }, 3000)
        },
        descargarCertificado() {
            this.popupActivo = false
            const nombreArchivo = 'certificado_' + (this.encuesta.codigo || 'encuesta').replace('ENC_', 'CAP_')
            document.title = nombreArchivo
            setTimeout(() => {
                window.print()
            }, 1000)
        }
    }
}
</script>

<style>
@font-face {
    font-family: "font_diploma";
    src: url("../../../assets/images/seminarios/SavoyePlain.otf");
}
.contenedor-cert {
    position: relative;
    display: inline-block;
    text-align: center;
    width: 100%;
}
@media print {
    .vs-popup--background,
    .vs-popup--content {
        display: none !important;
    }
}
</style>
